/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import React from 'react';
import Slider from 'react-slick';
import { gql, useQuery } from '@apollo/client';
import LoadingPlaceholder from '../LoaderContainer/LoadingPlaceholder';
import ClampLines from 'react-clamp-lines';
import './testimonials.scss'

const settings = {
  dots: true,
  speed: 500,
  autoplaySpeed: 10000,
  autoplay: true,
  infinite: true,
  arrows: true,
  draggable: true,
  touchMove: true,
  swipeToSlide: true,
  cssEase: 'cubic-bezier(0.165, 0.84, 0.44, 1)',
  swipe: true,
  slidesToShow: 1,
  pauseOnHover: true
};

interface Testimonial {
  id: string;
  partner: string;
  testimonial: string;
  logo: {
    handle: string;
  }
}


const FeedQuery = gql`
  query ($tags: [TestimonialTag!]) {
    testimonials(where: {tags_contains_some: $tags}, orderBy: createdAt_DESC, stage: PUBLISHED) {
      id
      partner
      testimonial
      logo {
        handle
      }
    }
  }
`;


interface QueryResult {
  testimonials: Testimonial[]
}

type TestimonialTags = 'singapore' | 'london';

export interface TestimonialsProps {
  tags: TestimonialTags[]
}

export const Testimonials = ({ tags }: TestimonialsProps) => {
  const { loading, error, data } = useQuery<QueryResult>(FeedQuery, {
    variables: {
      tags
    }
  });

  if (error || !data?.testimonials) {
    return <></>
  }

  return (
    <section className='testimonials'>
      <div className='row__inner'>
        <LoadingPlaceholder count={1} height={120} isLoading={loading} >
          <Slider {...settings}>
            {data.testimonials.map((testimonial, i) =>
              <div key={i} className='d-flex flex-column flex-lg-row px-4 testimonial__slide-inner'>
                {testimonial.logo && (
                  <div className='testimonials__logo_container mx-3 py-3'>
                    <img
                      className='testimonials__logo'
                      src={`https://media.graphcms.com/compress/${testimonial.logo.handle}`}
                      alt={`${testimonial.partner} Logo`}
                    />
                  </div>
                )}
                <div className='testimonials__content mx-3'>
                  <div className='strong my-2'>
                    {testimonial.partner}
                  </div>
                  <div className='testimonials__spiel'>
                    <ClampLines id={`testimonial_${testimonial.id}`} text={testimonial.testimonial} />
                  </div>
                </div>
              </div>
            )}
          </Slider>
        </LoadingPlaceholder>
      </div>
    </section>
  );
}


